import React, { useCallback } from 'react';
import waterMarkThemeLightUrl from '../../../assets/images/eye-watermark-light.svg';
import waterMarkThemeDarkUrl from '../../../assets/images/eye-watermark-dark.svg';
import alertWaterMark from '../../../assets/images/alert-watermark.svg';

import { Loading } from '../../Loading';
import * as Ui from './styles';
import light from '../../../assets/style/themes/light';
import { cardsMap } from 'src/sections/GroupCards/cardsMap';
import { useEventBus } from 'src/hooks';
import { ON_OPEN_SIMPLE_CROSS_CONFIG } from 'src/hooks/EventBus/eventTypes';

const defaultProps = {
  text: 'Empty',
};

const propsByCardId = {
  EvolutiveCross() {
    const eventBus = useEventBus();

    function notifyOpenSimpleCrossConfig() {
      eventBus.notify(ON_OPEN_SIMPLE_CROSS_CONFIG);
    }

    return (
      <Ui.Space>
        <Ui.WaterMark src={alertWaterMark} />
        <Ui.TextWrapper>
          <Ui.InfoText>{'Cruzamento simples não configurado'}</Ui.InfoText>
          <Ui.TextRow />
          <Ui.HelperText>{'Configure um Cruzamento Simples antes de criar o Evolutivo de Cruzamentos.'}</Ui.HelperText>
          <Ui.CallToActionButton
            title={'CONFIGURAR CRUZAMENTO SIMPLES'}
            onClick={notifyOpenSimpleCrossConfig}
          />
        </Ui.TextWrapper>
      </Ui.Space>
    );
  },
  Default(themeTitle) {
    const waterMarkUrl = themeTitle === light ? waterMarkThemeLightUrl : waterMarkThemeDarkUrl;
    return (
      <Ui.Space>
        <Ui.WaterMark src={waterMarkUrl} />
        <Ui.TextWrapper>
          <Ui.InfoText>{'Visualize seus resultados'}</Ui.InfoText>
          <Ui.TextRow />
          <Ui.HelperText>{'Selecione sua avaliação e pergunta para construir seus primeiros gráficos'}</Ui.HelperText>
        </Ui.TextWrapper>
      </Ui.Space>
    );
  },
};

export default function EmptyChart(props) {
  const { loading, theme, cardId, isCustomEmptyChart } = props;

  const getEmptyComponent = useCallback(() => {
    if (!isCustomEmptyChart) return propsByCardId.Default;
  
    return cardId === cardsMap.graficoEvolutivoCruzamentos.cardId
      ? propsByCardId.EvolutiveCross : propsByCardId.Default;
  }, [cardId, isCustomEmptyChart, propsByCardId]);

  const emptyComponent = getEmptyComponent(cardId, theme, isCustomEmptyChart);

  return (
    <>
      <Ui.Container>
        {loading ? <Loading size={30} running /> : emptyComponent(theme)}
      </Ui.Container>
    </>
  );
}

EmptyChart.defaultProps = defaultProps;
